import {
  UpdateProfileRequest,
  UpdateProfileResponse,
} from '@/apis/aniftyBackend/account/interface';
import client from '@/apis/aniftyBackend/client';
import checkAccessToken from '@/apis/aniftyBackend/utils/checkAccessToken';

const updateProfile = async (
  userID: string,
  data: UpdateProfileRequest
): Promise<UpdateProfileResponse> => {
  checkAccessToken();

  const response = await client.patch<UpdateProfileResponse>(
    `api/users/${userID}`,
    data
  );

  return response.data;
};

export default updateProfile;
